
import Footer from '../../components/feature/Footer';
import Header from '../../components/feature/Header';
import AccountSection from './components/AccountSection';

function Account() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <AccountSection />
      </main>
      <Footer />
    </div>
  );
}

export default Account;
